import { render, staticRenderFns } from "./StatusContoller.vue?vue&type=template&id=a6c340a0&scoped=true&"
import script from "./StatusContoller.vue?vue&type=script&lang=ts&"
export * from "./StatusContoller.vue?vue&type=script&lang=ts&"
import style0 from "./StatusContoller.vue?vue&type=style&index=0&id=a6c340a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c340a0",
  null
  
)

export default component.exports